import { createFileRoute } from "@tanstack/react-router";

import { ClosedRepairsCommissionsPage } from "@/modules/commissions/pages/ClosedRepairsCommissions.page";

export const Route = createFileRoute("/__authed/m/commissions/closed-repairs")({
	component: ClosedRepairsCommissionsPage,
});
